function TeamPage({
  title = "Team Rooms",
  description = "",
  metricsNode = null,
  showcaseNode = null,
  tabsNode = null,
  gateNode = null,
  bodyNode = null,
  children = null,
  activeTeam = null,
  activeTeamMembers = [],
  pendingInviteCount = 0,
}) {
  return (
    <section id="teams" className="appRoutePage teamRoutePage productSection teamsPage">
      <div className="routePageHeader teamPageHeader">
        <div className="teamPageHero">
          <div className="teamPageHeroCopy">
            <span className="leaguePageEyebrow">{activeTeam ? "My Team" : title}</span>
            <h1>{title}</h1>
            <p>{activeTeam ? `${activeTeam.name}. ${activeTeam.bio || description}` : description}</p>
          </div>
          {activeTeam ? (
            <div className="teamPageSummaryCard">
              <div>
                <small>Players</small>
                <strong>{activeTeamMembers.length || activeTeam.member_count || 0}</strong>
              </div>
              <div>
                <small>Site Rating</small>
                <strong>{activeTeam.competitive_rating || 1500}</strong>
              </div>
              <div>
                <small>Invites</small>
                <strong>{pendingInviteCount}</strong>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {metricsNode}
      {showcaseNode}
      {tabsNode}
      {gateNode}
      <div className="teamRouteBody">{bodyNode || children}</div>
    </section>
  );
}

export default TeamPage;
